import { isNullOrUndefined } from "util";
import { createEntityAdapter, EntityState } from "@ngrx/entity";
import { createReducer, on } from "@ngrx/store";
import { DiagnosisCodeApiActions } from "../actions/action-index";
import { DiagnosisCode } from "./models/diagnosis-code";

export const featureKey = "diagnosisCodes";

export type DiagnosisCodeState = EntityState<DiagnosisCode>

export const adapter = createEntityAdapter<DiagnosisCode>({
  selectId: (diagnosisCode) => diagnosisCode.id,
  sortComparer: (a, b) => {
    if (a.sortOrder === b.sortOrder) {
      if (a.category.sortOrder === b.category.sortOrder) {
        return a.code.localeCompare(b.code);
      }

      return a.category.sortOrder > b.category.sortOrder ? 1 : -1;
    }
    return a.sortOrder > b.sortOrder ? 1 : -1;
  },
});

export const initialState: DiagnosisCodeState = adapter.getInitialState([]);

export const reducer = createReducer(
  initialState,
  on(DiagnosisCodeApiActions.loadSuccess, (state, { diagnosisCodes }) =>
    adapter.setAll(
      diagnosisCodes.map((d) => ({
        code: d.code,
        description: d.description,
        id: d.id,
        isActive: d.isActive,
        isCommon: d.isCommon,
        sortOrder: isNullOrUndefined(d.sortOrder)
          ? Number.MAX_VALUE
          : d.sortOrder,
        category: {
          id: d.category.id,
          isActive: d.category.isActive,
          name: d.category.name,
          sortOrder: isNullOrUndefined(d.category.sortOrder)
            ? Number.MAX_VALUE
            : d.category.sortOrder,
        },
      })),
      state
    )
  )
);
